import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import store from './app/store';
import App from './App';
import ErrorBoundary from './app/layouts/ErrorBound';
import { LivekitRuntimeProvider } from './app/sdk/livekit';
import ToastProvider from "react-toaster-minimal";
import Container from '@material-ui/core/Container';

ReactDOM.render((
  <Provider store={store}>
    <BrowserRouter>
      <LivekitRuntimeProvider>
      <ErrorBoundary>
      <ToastProvider>
        <Container disableGutters={true} maxWidth={false} style={{ height: '100vh'}}>
          <App />
        </Container>
      </ToastProvider>
      </ErrorBoundary>
      </LivekitRuntimeProvider>
    </BrowserRouter>
  </Provider>
), document.getElementById('root'));

serviceWorker.unregister();
